import React, { useState } from "react";
import { FiLoader, FiSearch, FiUser } from "react-icons/fi";
import { useCourse } from "../context/CourseContext";
import { useAuth } from "../context/AuthContext";
import { apiGet, useAccountQuery } from "../utils/queries";

const Learners = () => {
  const { course } = useCourse();
  const [query, setQuery] = useState("");
  const { userId } = useAuth();
  const result = useAccountQuery(["members", course._id], null, {
    queryFn: async ({ signal }) => {
      const [members, progress] = await Promise.all([
        apiGet(`/workspace/manageMembers/${course._id}`, signal),
        apiGet(`/groups/${course._id}/member-progress`, signal),
      ]);
      return { members, progress: Object.fromEntries(progress.progress.map(item => [item.user, item])) };
    },
    enabled: Boolean(userId && course?._id),
  });
  const members = result.data?.members;
  const progress = result.data?.progress || {};
  const error = result.error?.message || "";
  const filtered = members?.filter(member => `${member.userId?.username || "Member"} ${member.role}`.toLowerCase().includes(query.trim().toLowerCase()));
  return (
    <main className="mx-auto max-w-3xl px-4 py-8 sm:px-8">
      <div className="mb-8 flex flex-wrap items-center justify-between gap-4">
        <label className="flex h-10 w-full items-center gap-2 rounded-md border border-gray-300 bg-white px-3 sm:w-64"><FiSearch aria-hidden="true" className="shrink-0 text-gray-400" /><input aria-label="Search members" placeholder="Search members" value={query} onChange={event => setQuery(event.target.value)} className="min-w-0 w-full bg-transparent text-sm outline-none" /></label>
      </div>
      {error && !members ? <div><p role="alert" className="text-sm text-red-700">{error}</p><button onClick={() => result.refetch()} className="mt-3 rounded-md border border-gray-300 px-3 py-2 text-sm">Try again</button></div>
        : !members ? <div role="status" aria-label="Loading members" className="flex min-h-48 items-center justify-center"><FiLoader className="h-6 w-6 animate-spin text-orange-700" /></div>
          : <ul aria-label="Members" className="grid grid-cols-1 items-start gap-7">
            {filtered.map((member, index) => {
              const saved = progress[member.userId?._id];
              return <li key={member.userId?._id || index} className="relative grid min-w-0 grid-cols-[minmax(0,1fr)_7rem] items-center gap-4 rounded-lg border border-gray-300 bg-white px-4 pb-4 pt-6 shadow-sm sm:grid-cols-[minmax(0,1fr)_11rem]">
              <div className="flex min-w-0 items-center gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-blue-50 text-blue-700"><FiUser aria-hidden="true" /></span>
              <span className="min-w-0 flex-1 break-words text-sm font-medium">{member.userId?.username || "Member"}</span>
              </div>
              <span className={`absolute -top-3 right-3 rounded border border-gray-300 px-2 py-0.5 text-xs font-semibold capitalize shadow-sm ${member.role === "owner" ? "bg-amber-50 text-amber-800" : member.role === "admin" ? "bg-orange-50 text-orange-800" : "bg-gray-100 text-gray-600"}`}>{member.role}</span>
              {saved && <div className="min-w-0">
                <div className="mb-1.5 flex items-center justify-between gap-2 text-xs font-medium text-gray-700"><span>{saved.completed} / {saved.total} lessons</span><span>{saved.percentage}%</span></div>
                <div role="progressbar" aria-label={`${member.userId?.username || "Member"} lesson progress`} aria-valuemin={0} aria-valuemax={100} aria-valuenow={saved.percentage} className="h-2 overflow-hidden rounded-full bg-gray-200">
                  <div className="h-full rounded-full bg-green-600" style={{ width: `${saved.percentage}%` }} />
                </div>
              </div>}
            </li>; })}
            {!filtered.length && <li className="col-span-full py-12 text-center text-sm text-gray-500">{query ? "No matching members." : "No members yet."}</li>}
          </ul>}
    </main>
  );
};
export default Learners;
